import React, { Component } from "react";
import history from "../Utils/History";
import { signUp, guestLogin } from "../Redux/Actions/webAppActions";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import SimpleReactValidator from "simple-react-validator";
import { connect } from "react-redux";
import { INITIAL_STATE } from "./InitialState";
// import { ListItemText } from "@material-ui/core";

class UserCreation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // email: "",

      // pswd: "",
      // reenterpassword: "",
      email: "",
      pswd: "",
      conf_pd: "",
      showPassword: false,
      passwordEye: false,
      showConfirmPassword: false,
      confirmPasswordEye: false,
      emailError: false,
      passwordError: false,
      confirmPasswordError: false,
      modified: false,
    };
    this.validator = new SimpleReactValidator();
  }
  selectYear = () => {
    history.push("/webapp/IndyHealth/yearSelectionGuest");
  };
  componentDidMount() {
    window.scroll(0, 0);
  }
  handleChange = (event) => {
    const { pswd } = this.state;
    const name = event.target.name;
    const value = event.target.value;
    const emailError =
      name === "email" &&
      (!this.validator.check(value, "email") || value === "");
    const passwordError = name === "pswd" && value === "";
    const confirmPasswordError =
      name === "conf_pd" && (value === "" || pswd !== value);

    this.setState({
      [name]: value,
      emailError: emailError,
      passwordError: passwordError,
      confirmPasswordError: confirmPasswordError,
      modified: true,
    });
  };

  handleFocus = (name) => (event) => {
    event.preventDefault();
    const showPasswordEye = name === "pswd";
    const showConfirmPasswordEye = name === "conf_pd";
    this.setState({
      passwordEye: showPasswordEye,
      confirmPasswordEye: showConfirmPasswordEye,
    });
  };

  handleOnBlur = (name) => (event) => {
    event.preventDefault();
    const {
      showConfirmPassword,
      showPassword,
      email,
      pswd,
      conf_pd,
    } = this.state;
    const showPasswordEye = name === "pswd" && showPassword;
    const showConfirmPasswordEye =
      name === "conf_pd" && showConfirmPassword;
    const emailError =
      name === "email" &&
      (!this.validator.check(email, "email") || email === "");
    const passwordError = pswd === "";
    const confirmPasswordError =
      conf_pd === "" || pswd !== conf_pd;
    this.setState({
      passwordEye: showPasswordEye,
      confirmPasswordEye: showConfirmPasswordEye,
      emailError: emailError,
      passwordError: passwordError,
      confirmPasswordError: confirmPasswordError,
    });
  };

  showPassword = (name, toggle) => (event) => {
    document.getElementById(name).focus();
    const eyeIcon = name === "pswd" ? "passwordEye" : "confirmPasswordEye";
    const show = name === "pswd" ? "showPassword" : "showConfirmPassword";
    this.setState({
      [eyeIcon]: true,
      [show]: toggle,
    });
  };

  signUp = async () => {
    const { email, pswd, conf_pd } = this.state;

    const emailError = !this.validator.check(email, "email") || email === "";

    const confirmPasswordError =
      conf_pd === "" || pswd !== conf_pd;

    if (emailError) {
      alert("Email format is incorrect");
      return;
    }
    if (!pswd) {
      alert("Please enter pswd");
      return;
    }
    if (confirmPasswordError) {
      alert("Passwords do not match - Please Re-enter");
      return;
    }
    let body = {
      emailAddress: email,
      pswd: pswd,
      reconfirmPwd: conf_pd,
    };

    body = { ...body, customerId: INITIAL_STATE.customerId };

    const signup = await this.props.signUp(body);
    if (signup.message === "SUCCESS")
      history.push("/webapp/IndyHealth/yearSelection");
    else alert(signup.message);
  };
  continueAsGuest = async (e) => {
    // e.preventDefault();
    const guestLogin1 = await this.props.guestLogin(INITIAL_STATE.customerId);
    if (guestLogin1.data === "Logged in as guest")
      history.push("/webapp/IndyHealth/yearSelectionGuest");
    else alert("Login Failed");
  };
  login = (e) => {
    e.preventDefault();
    history.push("/webapp/IndyHealth/userLogin");
  };

  render() {
    const {
      showPassword,
      showConfirmPassword,
      passwordEye,
      confirmPasswordEye,
      emailError,
      passwordError,
      confirmPasswordError,
    } = this.state;
    return (
      <React.Fragment>
        <div id="content" class="site-content">
          <div id="primary" class="content-area">
            <main id="main" class="site-main">
              <article
                id="post-2"
                class="post-2 page type-page status-publish hentry"
              >
                <header id="home" class="entry-header hide">
                  <h1 class="entry-title">Home</h1>
                </header>

                <div class="entry-content margin-top7">
                  <div class="wp-block-editor-blocks-wrapper alignfull page-section bg-gray">
                    <div class="wrapper-inner">
                      <div class="wrapper-inner-blocks">
                        <h2 id="home" class="text-center">
                          Create a Health Plan Medicare Account
                        </h2>
                        <p class="text-center">
                          Health Plan provides you with access to expert care
                          and award-winning facilities and programs that help
                          you make the most of your health care. We're here to
                          make finding and enrolling in the right plan simple.
                          Whether you have never purchased Medicare health
                          coverage before or are considering switching from your
                          current plan, we are committed to making your health
                          care experience affordable, simple, accessible and
                          personal. At Health plan, we offer Medicare plans to
                          feel good about.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="wp-block-editor-blocks-wrapper alignfull page-section2">
                    <div class="wrapper-inner">
                      <div class="tab-contentindy">
                        <div class="container form-panel">
                          <div class="form-group row">
                            <div class="col-md-12">
                              <label
                                for="email-address"
                                class="control-label"
                                style={{ padding: "0px !important" }}
                              >
                                Email Address*
                              </label>
                              <input
                                type="text"
                                id="email-address"
                                name="email"
                                class={
                                  this.state.email === "" || emailError
                                    ? "error-input"
                                    : "form-control"
                                }
                                required=""
                                value={this.state.email}
                                onChange={this.handleChange}
                                onBlur={this.handleOnBlur("email")}
                              />
                              <br />
                              <label for="pswd" class="control-label">
                                pswd*
                              </label>
                              <input
                                type={showPassword ? "text" : "pswd"}
                                id="pswd"
                                class={
                                  this.state.pswd === "" || passwordError
                                    ? "error-input"
                                    : "form-control"
                                }
                                name="pswd"
                                required=""
                                value={this.state.pswd}
                                onFocus={this.handleFocus("pswd")}
                                onBlur={this.handleOnBlur("pswd")}
                                onChange={this.handleChange}
                              />
                              {passwordEye ? (
                                <div
                                  class="eyeIcon-pswd"
                                  onMouseUp={this.showPassword(
                                    "pswd",
                                    false
                                  )}
                                  onMouseDown={this.showPassword(
                                    "pswd",
                                    true
                                  )}
                                  onMouseOut={this.showPassword(
                                    "pswd",
                                    false
                                  )}
                                >
                                  <RemoveRedEyeIcon />
                                </div>
                              ) : null}

                              <br />
                              <label
                                for="re-enter-pswd"
                                class="control-label"
                              >
                                Re-enter pswd*
                              </label>
                              <input
                                type={showConfirmPassword ? "text" : "pswd"}
                                id="conf_pd"
                                class={
                                  this.state.conf_pd === "" ||
                                  confirmPasswordError
                                    ? "error-input"
                                    : "form-control"
                                }
                                autoFocus
                                name="conf_pd"
                                required=""
                                value={this.state.conf_pd}
                                onFocus={this.handleFocus("conf_pd")}
                                onBlur={this.handleOnBlur("conf_pd")}
                                onChange={this.handleChange}
                              />
                              {confirmPasswordEye ? (
                                <div
                                  class="eyeIcon-confirm-pswd"
                                  onMouseUp={this.showPassword(
                                    "conf_pd",
                                    false
                                  )}
                                  onMouseDown={this.showPassword(
                                    "conf_pd",
                                    true
                                  )}
                                  onMouseOut={this.showPassword(
                                    "conf_pd",
                                    false
                                  )}
                                >
                                  <RemoveRedEyeIcon
                                    onClick={this.showPassword}
                                  />
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div class="button-container-login-pageindy">
                            <button
                              class="button2 mr-3"
                              id="continue-as-a-guest"
                              onClick={this.continueAsGuest}
                            >
                              Continue as Guest
                            </button>
                            <button
                              class={
                                this.state.modified
                                  ? "button btn-save-n-continue"
                                  : "btn btn-secondary"
                              }
                              id="signup"
                              onClick={this.signUp}
                              style={{
                                padding: "9px 34px",
                                borderRadius: "50px",
                              }}
                            >
                              Sign-up
                            </button>
                            <div class="already-have-account">
                              <p>
                                Already have an account? <br />
                                <a href="# " onClick={this.login}>
                                  Log in here
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </main>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = {
  signUp,
  guestLogin,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCreation);
